var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var fs = require('fs');
var path = require('path');
var collectAllJSONFilesInCurrentDirectory = function () {
    console.log('__dirname', __dirname);
    var files = fs.readdirSync(__dirname);
    return files.filter(function (file) { return file.endsWith('.json') && file !== 'test.js'; });
};
function generateRandomString() {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < 5; i++) {
        randomString += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return randomString;
}
var readJSONFileAndParse = function (file) {
    var content = fs.readFileSync(path.join(__dirname, file), 'utf8');
    var json = JSON.parse(content);
    return json;
};
var writeJSONFile = function (file, json) {
    var content = JSON.stringify(json, null, 2);
    fs.writeFileSync(path.join(__dirname, file), content, 'utf8');
};
var analyze = function (json, existingIds) {
    if (json.component !== 'div') {
        var children = json.children;
        if (children) {
            var items = children.map(function (child) {
                return analyze(child, existingIds);
            });
            var idVal = (json.id ? (!existingIds[json.id] ? { id: json.id } : { id: json.id + "_" + generateRandomString() }) : '');
            existingIds[json.id] = true;
            return __assign(__assign(__assign({}, json), { children: items }), idVal);
        }
        else {
            return json;
        }
    }
    else {
        if (json.children &&
            json.children.length == 1 &&
            json.children[0].component === 'label') {
            console.log('div', JSON.stringify(json.children));
            return __assign(__assign({}, json), { component: 'label_container' });
        }
        else {
            return json;
        }
    }
};
var inspect = function () {
    var files = collectAllJSONFilesInCurrentDirectory();
    console.log('files', files);
    files.forEach(function (file) {
        console.log('file', file);
        var json = readJSONFileAndParse(file);
        if (json.main) {
            var existingIds = {};
            var main = analyze(json.main, existingIds);
            var data = __assign(__assign({}, json), { main: main });
            writeJSONFile(file, data);
        }
        else {
            console.log('no main', file);
        }
    });
};
inspect();
//# sourceMappingURL=editJsonDef.js.map